export default __webpack_public_path__ + "static/illustration-2-5091302a70b6c74b64c103a851b56eae.png";